import { Component, Input, Output, EventEmitter } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { CardModule } from 'primeng/card'
import { ButtonModule } from 'primeng/button'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { InputTextModule } from 'primeng/inputtext'
import { TooltipModule } from 'primeng/tooltip'
import { OptimizationTour } from '../../affair-pool-optimization.component.model'
import { AffairOptimizationRunResponse } from '../../../../../interventions/services/interventions.service'
import { formatDate } from '../../pool-optimization-formatters'

@Component({
  selector: 'app-pool-tour-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    ButtonModule,
    ProgressSpinnerModule,
    InputTextModule,
    TooltipModule,
  ],
  templateUrl: './pool-tour-list.component.html',
  styleUrl: './pool-tour-list.component.scss',
})
export class PoolTourListComponent {
  @Input() tours: OptimizationTour[] = []
  @Input() filteredTours: OptimizationTour[] = []
  @Input() selectedTour: OptimizationTour | null = null
  @Input() recalculatingTourKeys = new Set<string>()
  @Input() run: AffairOptimizationRunResponse | null = null
  @Input() runCompleted = false
  @Input() launchLoading = false
  @Input() launchError: string | null = null
  @Input() canClearSelection = false
  @Input() searchQuery = ''
  @Input() selectedGroupingName = ''
  @Input() groupingNames: string[] = []
  @Input() hiddenMapGroups = new Set<string>()
  @Input() erosOnly = false

  @Output() tourSelected = new EventEmitter<OptimizationTour>()
  @Output() createAffairClicked = new EventEmitter<void>()
  @Output() addExistingAffairClicked = new EventEmitter<void>()
  @Output() clearSelectionAndSearch = new EventEmitter<void>()
  @Output() searchQueryChange = new EventEmitter<string>()
  @Output() selectedGroupingNameChange = new EventEmitter<string>()
  @Output() groupFilterChanged = new EventEmitter<void>()
  @Output() erosOnlyChange = new EventEmitter<boolean>()

  readonly formatDate = formatDate

  /** La proposition de cette tournée implique-t-elle un changement de jour ? */
  requiresDayShift(tour: OptimizationTour): boolean {
    return tour.tourData?.requires_day_shift === true
  }

  /** Nombre d'interventions programmées à déplacer sur un autre jour. */
  dayShiftCount(tour: OptimizationTour): number {
    const moves = tour.tourData?.day_shift_moves
    return Array.isArray(moves) ? moves.length : 0
  }

  onGroupingChange(value: string): void {
    this.selectedGroupingNameChange.emit(value)
    this.groupFilterChanged.emit()
  }
}
